export type I18nBlock = {
  id: string;
  type: string;
  data: Record<string, unknown>;
};

export type I18nPagePayload = {
  page: Record<string, unknown>;
  blocks: I18nBlock[];
  global: Record<string, unknown>;
  computed: {
    months_to_wedding: number;
    monthdays_to_wedding: number;
    is_wedding_day: boolean;
    is_after_wedding_day: boolean;
  };
  age_groups?: Record<string, { label: string }>;
  errors?: Record<string, string>;
};

export async function fetchPageI18n(page: string, lang: string): Promise<I18nPagePayload | null> {
  const url = `/api/v1/i18n/?page=${encodeURIComponent(page)}&lang=${encodeURIComponent(lang)}`;

  try {
    const res = await fetch(url, {
      headers: {
        Accept: "application/json",
      },
    });

    if (!res.ok) {
      console.warn("Failed to fetch i18n payload", { page, lang, status: res.status });
      return null;
    }

    const data = (await res.json()) as unknown;
    if (!data || typeof data !== "object") return null;

    const pageAny = (data as any).page;
    const blocksAny = (data as any).blocks;
    const globalAny = (data as any).global;
    const computedAny = (data as any).computed;
    const ageGroupsAny = (data as any).age_groups;
    const errorsAny = (data as any).errors;

    if (!pageAny || !blocksAny || !globalAny) return null;

    return {
      page: pageAny as Record<string, unknown>,
      blocks: blocksAny as I18nBlock[],
      global: globalAny as Record<string, unknown>,
      computed: computedAny as {
        months_to_wedding: number;
        monthdays_to_wedding: number;
        is_wedding_day: boolean;
        is_after_wedding_day: boolean;
      },
      age_groups: ageGroupsAny as Record<string, { label: string }> | undefined,
      errors: errorsAny as Record<string, string> | undefined,
    };
  } catch (err) {
    console.warn("Error while fetching i18n payload", err);
    return null;
  }
}
